import { GET_MEMBERSHIP,ADD_MEMBERSHIP, UPDATE_MEMBERSHIP, DELETE_MEMBERSHIP } from '../actions/actionTypes';

const initialState = {
  membershipData:[],membershipscardItemData:[],membershipstotalCount:0,membershipscardData:[],cardItemDataShow:false,opentost:false,tost_msg:''
};

function checkdate (data)  {
  let enddate =false;
let date1 =   JSON.parse(data).startDate;

  console.log('date1',date1);

  return date1;
}


export default function membership(state = initialState, action) {

  switch (action.type) {
     case GET_MEMBERSHIP:
      
      return{
       ...state,
       membershipData: action.membershipData,
       membershipscardData: action.getCardData,
       membershipstotalCount:action.totalCount,
       membershipscardItemData:action.cardItemData,
       cardItemDataShow:action.cardItemDataShow
      

      };
      case ADD_MEMBERSHIP:
        if(!action.newlyAddedMembership) {
          //membership could not be created, just return back the state
          return {
            ...state
          }
        }

        let updatedMemberships = state.membershipscardItemData
        if(!action.uploadedImage) {
          updatedMemberships.push(action.newlyAddedMembership)
        } else {
          updatedMemberships.push({ ...action.newlyAddedMembership, uploadedImage: action.uploadedImage })
        }

        let totalCount=0;
        let finaldata=[];
        let setCardItemDataShow=false;

        totalCount = updatedMemberships.length

        let getCardItemData = updatedMemberships.filter(item => item._deleted !== true).sort((a, b) => b.createdAt.localeCompare(a.createdAt));

        if(totalCount > 3) {
          setCardItemDataShow = true
        }

        if(getCardItemData.length > 0) {
          for (let i = 0; i < getCardItemData.length; i++) {
            const data = getCardItemData[i].newdata;
            let img =   getCardItemData[i].uploadedImage;
            if(img !="" && img!=undefined)
            {
                getCardItemData[i]['profile_image']=img;
            }
            let datecheck = checkdate(data);
  
            getCardItemData[i]['datecheck'] = datecheck;
  
            //restricted i.e. if education is publically viewable logic goes here. Add that logic if needed
  
            ///handling logic
          }
        }

        let getCardItemData2 = getCardItemData.sort((a, b) => Date.parse(b.datecheck) - Date.parse(a.datecheck))

        finaldata = getCardItemData2
        
        return{
          ...state,
          opentost:action.opentost,
          tost_msg:action.tost_msg,
          membershipscardItemData: finaldata.length > 3 ? finaldata.slice(0,3) : finaldata,  
          membershipstotalCount: totalCount,
          cardItemDataShow: setCardItemDataShow,
          // membershipData: action.getCardData,  
          membershipscardData: action.getCardData
        };

      case UPDATE_MEMBERSHIP:
        if(!action.updatedMembershipItem) {
          // update failed, return back the state
          return {
            ...state
          }
        }  

        const matchingMemItemIndex = state.membershipscardItemData.findIndex(memItem => memItem.id === action.updatedMembershipItem.id)

        let matchingMemItem = undefined
        if(matchingMemItemIndex !== -1) {
          matchingMemItem = state.membershipscardItemData[matchingMemItemIndex]
          matchingMemItem['profile_image'] = action.uploadedImage
          matchingMemItem['newdata'] = action.updatedMembershipItem.newdata
          if(matchingMemItem) {
            state.membershipscardItemData[matchingMemItemIndex] = matchingMemItem
          }
        } else {
          state.membershipscardItemData[matchingMemItemIndex] = matchingMemItem
        }

        return {
          ...state
        }
      
      case DELETE_MEMBERSHIP:
        console.log("action in delete membership", action)
        if(action.deleteSuccess) {
          const membershipsAfterDelete = action.membershipscardItemData
          
          let totalCountAfterDelete
          let finaldataAfterDelete=[];
          let setCardItemDataShowAfterDelete=false;

          totalCountAfterDelete = membershipsAfterDelete.length

          let cardItemsData = membershipsAfterDelete.filter(item => item._deleted !== true).sort((a, b) => b.createdAt.localeCompare(a.createdAt));


          if(totalCountAfterDelete > 3) {
            setCardItemDataShowAfterDelete = true
          }


          if(cardItemsData.length > 0){
            for(let i=0;i< cardItemsData.length;i++) {
              const data = cardItemsData[i].newdata;
              let img = cardItemsData[i].uploadedImage
              {
                cardItemsData[i]['profile_image']=img;
              }
              let datecheck = checkdate(data);
              cardItemsData[i]['datecheck'] = datecheck;
            }
          }

          let cardItemsData2 = cardItemsData.sort((a, b) => Date.parse(b.datecheck) - Date.parse(a.datecheck))

          finaldataAfterDelete = cardItemsData2

          return {
            ...state,
            membershipscardItemData: finaldataAfterDelete,
            membershipstotalCount: totalCountAfterDelete,
            cardItemDataShow: setCardItemDataShowAfterDelete
          }
        } else {
          //delete was not successful
          return {
            ...state
          }
        }  
      
      default: return state;
  }
};

